import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import NoAccessPage from "common/noAccessPage";
import banner from "svg/banner.svg";

const NotFound = () => {
  const { fcRole } = useSelector((state) => state.loggedInUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (fcRole && fcRole !== "") {
      if (fcRole === "FcNA") {
        navigate("/laborTable");
      } else {
        navigate("/siteRepo");
      }
    }
  }, [fcRole]);

  return <div>{(!fcRole || fcRole === "") && <NoAccessPage />}</div>;
};

export default NotFound;
